import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";
import {FloorChoice} from "../../../real_estate/types/FloorChoice";

export const getOfferStatsByUserPrefFloor = (
    userPref?: {filters?: {floor_choices?: string[]}} | null,
    stats?: IOfferDetailStats["building_parameters_stats"]
) => {
    const userFloor = userPref?.filters?.floor_choices;

    if (userFloor?.includes(FloorChoice.LOW_LEVELS.toString()) && stats?.properties_on_low_floor) {
        return {
            left: stats.properties_on_low_floor.left,
            total: stats.properties_on_low_floor.total,
            label: "na niskim piętrze"
        };
    }

    if (userFloor?.includes(FloorChoice.HIGH_LEVELS.toString()) && stats?.properties_on_middle_floors) {
        return {
            left: stats.properties_on_middle_floors.left,
            total: stats.properties_on_middle_floors.total,
            label: "na średnim piętrze"
        };
    }

    if (
        (userFloor?.includes(FloorChoice.LAST_LEVEL_WITH_TERRACE.toString()) || userFloor?.includes(FloorChoice.LAST_LEVEL.toString())) &&
        stats?.properties_on_high_floors
    ) {
        return {
            left: stats.properties_on_high_floors.left,
            total: stats.properties_on_high_floors.total,
            label: "na wysokim piętrze"
        };
    }

    return null;
};
import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";
import {FloorChoice} from "../../../real_estate/types/FloorChoice";

export const getOfferStatsByUserPrefFloor = (
    userPref?: {filters?: {floor_choices?: string[]}} | null,
    stats?: IOfferDetailStats["building_parameters_stats"]
) => {
    const userFloor = userPref?.filters?.floor_choices;

    if (userFloor?.includes(FloorChoice.LOW_LEVELS.toString()) && stats?.properties_on_low_floor) {
        return {
            left: stats.properties_on_low_floor.left,
            total: stats.properties_on_low_floor.total,
            label: "na niskim piętrze"
        };
    }

    if (userFloor?.includes(FloorChoice.HIGH_LEVELS.toString()) && stats?.properties_on_middle_floors) {
        return {
            left: stats.properties_on_middle_floors.left,
            total: stats.properties_on_middle_floors.total,
            label: "na średnim piętrze"
        };
    }

    if (
        (userFloor?.includes(FloorChoice.LAST_LEVEL_WITH_TERRACE.toString()) || userFloor?.includes(FloorChoice.LAST_LEVEL.toString())) &&
        stats?.properties_on_high_floors
    ) {
        return {
            left: stats.properties_on_high_floors.left,
            total: stats.properties_on_high_floors.total,
            label: "na wysokim piętrze"
        };
    }

    return null;
};
